// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"44568044cc663a4c","3412":"b545c8a42a832fcf","5247":"b545c8a42a832fcf","5874":"8c51f06a1252b31a","5983":"b545c8a42a832fcf"}[chunkId] + ".css";
};